const cnpjMask = [
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '/',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/
];

export const clienteFilterConfig = [
  {
    id: 'Nome',
    type: 'text',
    label: 'Nome',
    placeholder: 'Digite o nome do cliente',
  },
  {
    id: 'CNPJ',
    type: 'masked',
    label: 'CNPJ',
    placeholder: 'Digite o CNPJ',
    mask: cnpjMask,
    guide: false,
  },
];
